import {
  Component,
  OnDestroy,
  OnInit,
  inject,
  ChangeDetectionStrategy,
} from '@angular/core';
import { PasswordResetService } from '../../../services/password-reset/password-reset.service';
import {
  FormBuilder,
  Validators,
  FormsModule,
  ReactiveFormsModule,
} from '@angular/forms';
import { ToastService } from '@ui/global-shared/services';
import { markAllFormControls } from '@ui/global-shared/util/reactive-form-util';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { FormLabelComponent } from '@ui/global-shared/components/form-label/form-label.component';
import { Bind } from 'primeng/bind';
import { InputText } from 'primeng/inputtext';
import { FormErrorsComponent } from '@ui/global-shared/components/form-errors/form-errors.component';
import { Button } from 'primeng/button';

@Component({
  selector: 'pt-portal-passwordforgotten',
  templateUrl: './password-forgotten.component.html',
  styleUrls: ['./password-forgotten.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [
    FormsModule,
    ReactiveFormsModule,
    FormLabelComponent,
    Bind,
    InputText,
    FormErrorsComponent,
    Button,
  ],
})
export class PasswordForgottenComponent implements OnInit, OnDestroy {
  private passwordResetService = inject(PasswordResetService);
  private formBuilder = inject(FormBuilder);
  private toaster = inject(ToastService);

  requestSuccessful = false;
  passwordReset: PasswordForgottenForm;

  #destroy$ = new Subject<void>();

  ngOnInit(): void {
    this.passwordReset = this.buildForm();
  }

  ngOnDestroy(): void {
    this.#destroy$.next();
    this.#destroy$.complete();
  }

  sendPasswordForgottenMail(): void {
    if (!this.passwordReset.valid) {
      markAllFormControls(this.passwordReset);
      this.toaster.formErrorsToast();
      return;
    }

    const usrCtrl = this.passwordReset.get('username');

    this.passwordResetService
      .requestPasswordResetToken(usrCtrl.value)
      .pipe(takeUntil(this.#destroy$))
      .subscribe();

    // ignore error case for avoiding attack vectors
    this.requestSuccessful = true;
  }

  private readonly buildForm = () =>
    this.formBuilder.group({
      username: ['', Validators.required],
    });
}

type PasswordForgottenForm = ReturnType<
  PasswordForgottenComponent['buildForm']
>;
